import React, { lazy, Suspense } from "react";
import DNVSpinner from "./components/DNVSpinner";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { FileStatesProvider } from "./contexts/FileStatesContext";
import UserSessionsPage from "./pages/UserSessionsPage";
import SessionRunPage from "./pages/SessionRunPage";
import SessionSummaryPage from "./pages/SessionSummaryPage";
import MaintenancePage from "./pages/MaintenancePage";
const HomePage = lazy(() => import("./pages/HomePage"));
const CASTestingPage = lazy(() => import("./pages/CASTestingPage"));
const CustomProfilesTestingPage = lazy(() => import("./pages/CustomProfilesTestingPage"));
const CustomProfileSetupPage = lazy(() => import("./pages/CustomProfileSetupPage"));
const ValidationPage = lazy(() => import("./pages/ValidationPage"));
const ContextDrivenRulesPage = lazy(() => import("./pages/ContextDrivenRulesPage"));
const SchemaDrivenRulesPage = lazy(() => import("./pages/SchemaDrivenRulesPage"));
const SessionSetupPage = lazy(() => import("./pages/SessionSetupPage"));
const ErrorPage = lazy(() => import("./pages/ErrorPage"));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage"));
const AdminPage = lazy(() => import("./pages/AdminPage"));

function App() {
  return (
    <Router>
      <FileStatesProvider>
        <Suspense fallback={<DNVSpinner land={true} sea={true} air={true} />}>
          <Switch>
          <Route path="/admin">
            <AdminPage />
          </Route>
          <Route exact path="/users">
            <UserSessionsPage />
          </Route>
          <Route exact path="/cimbion-conformance-testing">
            <CASTestingPage />
          </Route>
          {/* TEMP until unSHACLed go-live: block all unSHACLed pages */}
          <Route path={["/cimbion-unshacled", "/unshacled"]}>
            <NotFoundPage />
          </Route>
          <Route exact path="/cimbion-unshacled">
            <CustomProfilesTestingPage />
          </Route>
          <Route exact path="/unshacled/setup">
            <CustomProfileSetupPage />
          </Route>
          <Route path="/unshacled/setup/:sessionId">
            <CustomProfileSetupPage />
          </Route>
          <Route path="/unshacled/run/:sessionId/validation">
            <ValidationPage />
          </Route>
          <Route path="/unshacled/run/:sessionId/context-driven-rules">
            <ContextDrivenRulesPage />
          </Route>
          <Route path="/unshacled/run/:sessionId/schema-driven-rules">
            <SchemaDrivenRulesPage />
          </Route>
          <Route exact path="/setup">
            <SessionSetupPage />
          </Route>
          <Route path="/setup/:sessionId" component={SessionSetupPage} />
          <Route path="/runSession/:sessionId" component={SessionRunPage} />
          <Route
            path="/sessionSummary/:sessionId"
            component={SessionSummaryPage}
          />
          <Route path="/maintenance">
            <MaintenancePage />
          </Route>
          <Route path="/Error">
            <ErrorPage />
          </Route>
          <Route path="/" exact>
            <HomePage />
          </Route>
          <Route path='*'>
            <NotFoundPage />
          </Route>
          </Switch>
        </Suspense>
      </FileStatesProvider>
    </Router>
  );
}

export default App;
